<script>
import { commands } from '../../js/lib/functions.js';
import { listenToAllEmailCampaignViews } from '../../js/readModel.js';
import { showConfirm } from '../../js/utils/confirm.js';
import { hideLoading, showLoading } from '../../js/utils/loading.js';
import { showToast } from '../../js/utils/toast.js'

export const pageName = 'admin-email-campaigns';
export const pageRoute = '/admin/email-campaigns';
export const title = 'Email Campaigns'
export const requireAdmin = true;

export default {
	data() {
		return { 
			campaigns: [],
			ready: false
		}
	},
	methods: {
		async boot(opts)
		{
			await listenToAllEmailCampaignViews(this.campaigns)
			this.ready = true;
		},
		async count(campaignId) {			
			showLoading();

			let result = await commands.emailCampaigns.count({
				campaignId
			})
			
			hideLoading();

			showConfirm({
				title: 'Query results',
				message: `You would be emailing ${result.recipients} people.`,
				dismissable: false,
				buttons: [
					{
						text: 'Got it',
						style: 'primary'
					}
				]
			})
		},
		async sendTest(campaignId) {			
			showLoading();

			let result = await commands.emailCampaigns.test({
				campaignId
			})
			
			if(!result.success)
			{
				showToast({
					message: 'Error sending test email',
					style: 'bg-danger'
				})
				return;
			}

			showToast({
				message: 'Sent to you',
				style: 'bg-success'
			})

			hideLoading();
		},
		async send(campaignId) {			
			showLoading();

			let result = await commands.emailCampaigns.send({
				campaignId
			})
			
			if(!result.success)
			{
				showToast({
					message: 'Error sending email, contact system administrator',
					style: 'bg-danger'
				})
				return;
			}

			showToast({
				message: 'Sent to ' + result.recipients + ' people',
				style: 'bg-success'
			})

			hideLoading();
		},
		async deleteCampaign(campaignId) {			
			showLoading();

			let result = await commands.emailCampaigns.delete({
				campaignId
			})
			
			if(!result.success)
			{
				showToast({
					message: 'Error deleting email, contact system administrator',
					style: 'bg-danger'
				})
				return;
			}

			hideLoading();
		},
		async clone(campaignId) {			
			showLoading();

			let result = await commands.emailCampaigns.clone({
				campaignId
			})
			
			if(!result.success)
			{
				showToast({
					message: 'Error cloning email, contact system administrator',
					style: 'bg-danger'
				})
				return;
			}

			hideLoading();
		}
	}
}
</script>
<template>
<div class="container" v-if="ready">
    <form @submit.prevent="submit">
		<div class="row justify-content-center py-5">
			<div class="col-12 col-md-8">
				<h1 class="display-4 text-center mb-3">Email campaigns</h1>
				<p class="text-muted text-center mb-5">Send emails to the community</p>
				<p>
					<a href="/admin/email-campaigns/add" class="btn btn-primary btn-block">Add new campaign <span class="fe fe-plus-circle"></span></a>
				</p>
				<hr class="my-5">
				<div v-for="campaign in campaigns" class="card">
					<div class="card-header">
						<h4 class="card-header-title">{{ campaign.name }}</h4>
						<div v-if="campaign.sent" class="small">Sent: {{ campaign.sentOn }}</div>
					</div>
					<div v-if="campaign.sent" class="card-body">
						<div class="row text-center">
							<div class="col">
								<div class="text-muted display-4">{{ campaign.totalDeliveries }}</div>
								<div class="small">Deliveries</div>
							</div>
							<div class="col">
								<div class="text-muted display-4">{{ campaign.totalBounces }}</div>
								<div class="small">Bounces</div>
							</div>
							<div class="col">
								<div class="text-muted display-4">{{ campaign.totalComplaints }}</div>
								<div class="small">Complaints</div>
							</div>
							<div class="col">
								<div class="text-muted display-4">{{ campaign.totalOpens }}</div>
								<div class="small">Opens</div>
							</div>
							<div class="col">
								<div class="text-muted display-4">{{ campaign.totalInteractions }}</div>
								<div class="small">Interactions</div>
							</div>
						</div>
					</div>
					<div v-else class="card-body text-center">
						<p class="small text-muted mb-0">Unsent</p>
					</div>
					<div class="card-footer">
						<a v-if="!campaign.sent" :href="`/admin/email-campaigns/${campaign.id}/edit`" class="btn btn-sm btn-outline-primary">Edit <span class="fe fe-edit-2"></span></a>
						<button v-if="campaign.sent" class="btn btn-sm btn-outline-primary" disabled>Edit <span class="fe fe-edit-2"></span></button>
						<button @click.prevent="clone(campaign.id)" class="ml-2 btn btn-sm btn-outline-primary">Clone <span class="fe fe-copy"></span></button>
						<button @click.prevent="count(campaign.id)" :class="`ml-2 btn btn-sm ${campaign.counted ? 'btn-outline-primary' : 'btn-primary'}`" :disabled="campaign.sent">Count recipients <span class="fe fe-users"></span></button>
						<button @click.prevent="sendTest(campaign.id)" :class="`ml-2 btn btn-sm ${(!campaign.counted || campaign.tested) ? 'btn-outline-primary' : 'btn-primary'}`">Send to you <span class="fe fe-send"></span></button>
						<button @click.prevent="send(campaign.id)" class="ml-2 btn btn-sm btn-primary" :disabled="!campaign.counted || !campaign.tested || campaign.sent">Send <span class="fe fe-send"></span></button>
						<button @click.prevent="deleteCampaign(campaign.id)" class="ml-2 btn btn-sm btn-outline-danger">Delete <span class="fe fe-trash"></span></button>
						
						<a :href="`/admin/email-campaigns/${campaign.id}/view`" class="ml-2 btn btn-sm btn-outline-primary">View <span class="fe fe-eye"></span></a>
					</div>
				</div>
				<div v-if="!campaigns.length">
					<p class="text-center">You do not have any campaigns yet.</p>
				</div>
			</div>
		</div>
	</form>
</div>
</template>